/**
 * @type {{msgID: number, siteName: string, siteAdminName: string, siteAdminEmail: string}} SiteRequest
 */
export class SiteRequest {
	constructor(objPayload) {
        this.msgID = objPayload?.MsgID ?? -1;
		this.siteName = objPayload?.SiteName ?? '';
		this.siteAdminName = objPayload?.SiteAdminName ?? '';
		this.siteAdminEmail = objPayload?.SiteAdminEmail ?? '';
	}
}

/**
 * @type {{MsgID: number, SiteName: string, SiteAdminName: string}} SitePayload
 */
export class SitePayload {
	MsgID = -1;
	SiteName = '';
	SiteAdminName = '';
	constructor(msgID, siteName, siteAdminName) {
		this.MsgID = msgID;
		this.SiteName = siteName;
		this.SiteAdminName = siteAdminName;
	}
}

/**
 * @type {{UserID: number, SponsorEmail: string, Site: SiteRequest}} SponsorPayload
 */
export class SponsorPayload {
	UserID = -1;
	SponsorEmail = '';
	Site = null;

	constructor(userID, sponsorEmail, objSite) {
		this.UserID = userID;
		this.SponsorEmail = sponsorEmail;
		this.Site = objSite;
	}
}
